export const STORAGE_KEY = {
    FIRST_TIME_ACCESSING: 'app:firstTimeAccessing',
    ANSWER_LOCKED: 'app:answerLocked',
    QUESTION_ANSWER_ID: 'app:questionAnswerId'
}
